import { Box, Button } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import useWebSocket from "react-use-websocket";

const socketUrl = "wss://brmm0q8jaa.execute-api.eu-central-1.amazonaws.com/production";

const POSDisplayCart = ({ cart, vatDefinitions, returnCash, receipt }) => {

    const [cookies] = useCookies(["secret", "station", "staff"]);

    const { sendMessage } = useWebSocket(socketUrl, {
        queryParams: {
            station: cookies.station,
            secret: cookies.secret,
            staff: cookies.staff
        },
        shouldReconnect: () => true,
        onMessage: (msg) => handleMessage(msg)
    });
    const handleMessage = () => { return null; };
    const displayMessage = ({ data }) => {

        sendMessage(
            JSON.stringify({
                task: "displayMessagePOSRequest",
                station: cookies.station,
                staff: cookies.staff,
                data
            })
        );
    };



    const displayCart = () => {
        const data = {
            type: "CART",
            cart,
            vatDefinitions,
            returnCash,
            receipt: { ereceipt: { public_link: receipt?.ereceipt?.public_link } }
        };
        displayMessage({ data });
    }


    const emptyScreen = () => {
        const data = {
            type: "EMPTY",

        };
        displayMessage({ data });
    }


    const [prev, setPrev] = useState();

    useEffect(() => {
        if(cart.length > 0 || receipt.ereceipt || returnCash > 0){
            const cur = JSON.stringify({cart, receipt, returnCash});
            if(cur !== prev){
                setPrev(cur);
                displayCart();
            }
        }
    }, [cart, receipt, vatDefinitions, returnCash])

    const [mode, setMode] = useState(true); // true = ON; false = OFF

    const handleClick = () => {
        if (mode) {
            setMode(!mode)
            emptyScreen();
        } else {
            setMode(!mode)
            displayCart();
        }
    };
    return (

        <Button
        size="small"
            variant={mode ? "outlined" : "contained"}
            color={mode ? "primary" : "error"}
            onClick={handleClick}>Kunden-Display ({mode ? "AN" : "AUS!"})</Button>

    );
};

export default POSDisplayCart;

